module.exports = "<select class=\"form-control mx-auto\">\n    <option selected>---</option>\n    {{{timePicker}}}\n</select>"